module.exports = __webpack_public_path__ + "img/ic-fail.4b70aa7b.svg";